import {FC} from 'react'
import {downloadTemplateEnterprise, uploadMasiveEnterprise} from '../../../../services'
import {ShowSnackBar} from '../../../../../../util/functions'
import {FormMasive} from '../../../../../../components/UI/Form/MasiveV2'
import {ERROR_MESSAGE_SYSTEM} from '../../../../../../util/Constants'
const MasiveUploadEnterprise: FC = () => {
  const handleUpload = async (formData: FormData) => {
    try {
      const data = await uploadMasiveEnterprise(formData) // Use the service to upload the file
      return data
    } catch (error) {
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    }
  }
  return (
    <FormMasive
      serviceTemplate={downloadTemplateEnterprise}
      handleSendService={handleUpload}
      title='Empresa'
    />
  )
}

export {MasiveUploadEnterprise}
